// extracted by mini-css-extract-plugin
export var checkIcon = "reservation-part-1-module--check-icon--7381d";
export var reservationCheckbox = "reservation-part-1-module--reservation-checkbox--a8a8d";
export var reservationChoiceTypeContainer = "reservation-part-1-module--reservation-choice-type-container--c541c";
export var reservationLoadingSpinner = "reservation-part-1-module--reservation-loading-spinner--1fceb";
export var reservationLoadingWrapper = "reservation-part-1-module--reservation-loading-wrapper--4754a";
export var reservationSubContainer = "reservation-part-1-module--reservation-sub-container--936c3";
export var reservationTitle = "reservation-part-1-module--reservation-title--d1d9e";
export var spanContainer = "reservation-part-1-module--span-container--9ea10";